import api from '@/services/Api'

class ProductQuestionService {
  async getProductQuestionList(productBreakdownId) {
    const url = '/distributor/product-question/all-by-product-breakdown-id/' + productBreakdownId
    const response = await api.get(url)
    return response.data
  }
}

export default new ProductQuestionService()
